<template>
  <div>
    <ativar-ou-inativar-tipo-agendamento-dialog
      :is-ativar-ou-inativar-associacao-dialog-open.sync="isAtivarOuInativarTipoAgendamentolDialogOpen"
      :is-associacao-ativa-mensagem="isAssociacaoAtivaMensagem"
      :loading="loading"
      :close-dialog="closeDialog"
      :confirmar-ativacao-ou-inativacao-da-associacao="confirmarAtivacaoOuInativacaoDoTipoAgendamento"
    />

    <v-data-table
      no-data-text="Sem dados"
      :headers="headers"
      :items="items"
      :footer-props="{
        'items-per-page-text': 'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      :item-class="cursorPointer"
      @click:row="selecionarTipoAgendamento"
    >
      <template #[`item.nome`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
            size="32"
          >
            <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
              {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
            </span>
          </v-avatar>

          <div class="d-flex flex-column ms-3">
            {{ item.nome }}
          </div>
        </div>
      </template>

      <template #[`item.ativo`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              v-on="on"
              color="primary"
            >
              <v-icon @click="ativarOuInativarTipoAgendamento(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="openAssociarOuDesassociar"
              >
                <v-icon
                  size="20"
                  class="me-2"
                  small
                >
                  {{ item.ativo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize"> {{ isAssociacaoAtivaMensagem }} </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mdiCloseThick, mdiDotsVertical, mdiCheckBold } from '@mdi/js'
import { ref } from '@vue/composition-api'
import AtivarOuInativarTipoAgendamentoDialog from '@/views/ativar-ou-inativar-associacao-dialog/AtivarOuInativarAssociacaoDialog.vue'
import TipoAgendamentoService from '@/services/modules/TicketAgendamentoTipoService'

export default {
  components: {
    AtivarOuInativarTipoAgendamentoDialog,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
    selecionarTipoAgendamento: {
      type: Function,
      required: true,
    },
  },

  setup(_, { emit }) {
    const loading = ref(false)
    const isAssociacaoAtivaMensagem = ref('')
    const id = ref(0)
    const isAssociacaoAtiva = ref(undefined)
    const isAtivarOuInativarTipoAgendamentolDialogOpen = ref(false)

    function ativarOuInativarTipoAgendamento(item) {
      id.value = item.id
      isAssociacaoAtiva.value = item.ativo
      isAssociacaoAtivaMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }

    function openAssociarOuDesassociar() {
      isAtivarOuInativarTipoAgendamentolDialogOpen.value = true
    }
    function closeDialog() {
      isAtivarOuInativarTipoAgendamentolDialogOpen.value = false
    }

    async function confirmarAtivacaoOuInativacaoDoTipoAgendamento() {
      if (loading.value) return
      try {
        loading.value = true
        await TipoAgendamentoService.ativarOuInativarTipoDeAgendamento(id.value, { ativar: !isAssociacaoAtiva.value })
        emit('refetch-data')
      } finally {
        closeDialog()
        loading.value = false
      }
    }

    const headers = [
      { text: 'Nome', value: 'nome' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'Fila', value: 'filaNome' },
      { text: 'Status', value: 'ativo' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      isAtivarOuInativarTipoAgendamentolDialogOpen,
      isAssociacaoAtivaMensagem,
      loading,
      headers,
      ativarOuInativarTipoAgendamento,
      confirmarAtivacaoOuInativacaoDoTipoAgendamento,
      openAssociarOuDesassociar,
      closeDialog,
      icons: {
        mdiCloseThick,
        mdiDotsVertical,
        mdiCheckBold,
      },
      cursorPointer: () => 'cursor-pointer',
    }
  },
}
</script>
